import { TypedHtmlElements } from "@cervval.js/client-html5-core/src/components/typedHtmlElements.decorator";
import { FLEX_CONTAINER_COLUMN, FLEX_ITEM, H_100, PADDING, W_100 } from "@cervval.js/client-html5-core/src/tools/cssClasses.tools";
import { CustomElement, NAVIGATION_SERVICE, NavigationService, WebPageComponent } from "@cervval.js/client-html5-spa/navigation";
import { CjsIconFa } from "@cervval.js/client-html5-ui/src/components/icon/iconFa";
import { CjsSmartTable } from "@cervval.js/client-html5-ui/src/components/smartTable/smartTable";
import { Injected } from "@cervval.js/common/src/dependencies/injected";
import { BOOKING_SERVICE } from "@ehealth_tools/common-booking/src/services/abstractCommonBooking.service";
import { AbstractClientBookingService } from "../../../../services/abstractClientBooking.service";
import { BookingPageName } from "../../../booking.pages";
import { _I18nCalendar } from "./calendarPage.i18n";
import { CalendarDisplay } from "./components/calendarDisplay/calendarDisplay.component";


@CustomElement({
    name: "calendar-page",
    style: require("./calendarPage.scss"),
    template: require("./calendarPage.html"),
    i18n: require("./calendarPage.i18n").I18nCalendar(),
    elementCssClasses: [W_100, H_100, FLEX_CONTAINER_COLUMN, FLEX_ITEM, PADDING.PY_2]
})
export class CalendarPage<I18n extends _I18nCalendar = _I18nCalendar> extends WebPageComponent<I18n> {
    @TypedHtmlElements({ ensureLoadedClasses: [CjsSmartTable, CjsIconFa, CalendarDisplay] })
    public readonly components!: {
        container: HTMLDivElement,
        returnDiv: HTMLDivElement,
        returnIcon: CjsIconFa,
        returnTitle: HTMLDivElement,
        calendar: CalendarDisplay
    };

    @Injected(NAVIGATION_SERVICE)
    private readonly navigationService!: NavigationService<BookingPageName>;

    @Injected(BOOKING_SERVICE)
    private _bookingService!: AbstractClientBookingService;

    /** @inheritdoc */
    public override init(): void {
        this.components.returnDiv.addEventListener("click", () => {
            this.navigationService.navigate("profile");
        });
        this._initIcons();

        this.components.returnTitle.innerHTML = this.i18n.returnTitle;
    }

    /**
     * Init icons
     */
    private _initIcons(): void {
        this.components.returnIcon.options.setAndRefreshIfChanged({
            name: "fa-chevron-left"
        });
    }

    /** @inheritdoc */
    public override refresh(): void {
        this._refreshI18n();
        this.components.calendar.selectCalendar(this._bookingService.getCurrentUserCalendarData().calendar);
    }

    /**
     * Refresh i18n elements
     */
    private _refreshI18n(): void {

    }

}
